/* eslint-disable import/no-unresolved */
/* eslint-disable react/destructuring-assignment */
import {
  Autocomplete,
  Box, Button, CardContent, CircularProgress, FormControl, TextField, Typography,
} from '@mui/material'
import { useEffect, useState } from 'react';
import { cloneDeep, omit } from 'lodash';
import { useFormik } from 'formik';
import { AddUserInput, useListJobTitleLazyQuery } from '../../../../../graphql/generated/graphql';
import { FormContactsSchema } from './schema';

import './index.scss';
import { IJobTitle } from '../../../../config/interfaces';

const ContactsForm = (props: any) => {
  const { item } = props;
  const [listJobTitle, { data }] = useListJobTitleLazyQuery();
  const [selectJobTitle, setSelectJobTitle] = useState<IJobTitle[]>([]);
  useEffect(() => {
    listJobTitle();
  }, []);
  const [valueJobTitle, setValueJobTitle] = useState<IJobTitle>(!item.jobTitleId ? {
    name: item?.jobTitle,
    value: item?.JobTitleId,
  } : { name: '', value: '' });

  useEffect(() => {
    if (data?.listJobTitle) {
      const tempOptions = cloneDeep(data.listJobTitle);
      const result = tempOptions?.map((o) => ({
        label: o?.name,
        value: o?.id,
        ...omit(o, 'id'),
      }));
      setSelectJobTitle(result as []);
    }
  }, [data]);

  const initialValues: AddUserInput = {
    name: item?.name,
    email: item?.email,
    job_title_id: item?.JobTitleId,
  };

  const formik = useFormik({
    initialValues,
    validationSchema: FormContactsSchema,
    isInitialValid: FormContactsSchema.isValidSync(initialValues),
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = (e: any) => {
    if (formik.isValid) {
      props.handleSubmit(formik.values);
    }
  }

  return (
    <Box>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <Typography component="h1" variant="h3">
          Edit contact information
        </Typography>
      </Box>
      <CardContent sx={{ mt: 1 }}>
        <TextField
          margin="normal"
          fullWidth
          id="name"
          label="User name"
          name="name"
          autoComplete="name"
          disabled
          value={formik.values.name}
          onChange={formik.handleChange}
          error={formik.touched.name && Boolean(formik.errors.name)}
          helperText={formik.touched.name && formik.errors.name}
        />
        <TextField
          margin="normal"
          fullWidth
          name="Email"
          label="Email"
          id="email"
          disabled
          value={formik.values.email}
          onChange={formik.handleChange}
          error={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
        />
        <Autocomplete
          fullWidth
          id="job-title"
          disableClearable
          options={selectJobTitle}
          value={valueJobTitle}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          onChange={(event: any, newValue: any) => {
            setValueJobTitle(newValue)
            formik.setFieldValue('job_title_id', newValue.value)
          }}
          getOptionLabel={(option) => option.name}
          renderOption={(propsOptions, option) => (
            <Box
              component="li"
              {...propsOptions}
              key={option.value}
            >
              {option.name}
            </Box>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              name="jobTitle"
              label="Job title"
              error={formik.touched.job_title_id && Boolean(formik.errors.job_title_id)}
              helperText={formik.touched.job_title_id && formik.errors.job_title_id}
            />
          )}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          disabled={!(formik.isValid) || props.loading}
          onClick={(e: any) => handleSubmit(e)}
        >
          {
            (() => {
              if (props.loading) {
                return <CircularProgress color="secondary" size={20} />
              }

              return 'Save'
            })()
          }
        </Button>
      </CardContent>
    </Box>
  )
}

export default ContactsForm;
